import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  ApiRef,
  createApiRef,
  discoveryApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { AlmServicesPluginApi } from './apis/types';
import { AlmServiceApiClient } from './apis/AlmServiceApiClient';

export const AlmServicesPluginApiRef: ApiRef<AlmServicesPluginApi> =
  createApiRef({
    id: 'plugins.alm.services.api',
  });

const createAlmServicesApiFactory = (): AnyApiFactory => {
  return createApiFactory({
    api: AlmServicesPluginApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      identityApi: identityApiRef,
      configApi: configApiRef,
    },
    factory: ({ discoveryApi, identityApi, configApi }) =>
      new AlmServiceApiClient({ identityApi, configApi }),
  });
};

export const apis: AnyApiFactory[] = [createAlmServicesApiFactory()];
